var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "configuration-page" }, [
    _c("div", { staticClass: " configuration-container" }, [
      _c("div", { staticClass: "inputs-container" }, [
        _c("p", { staticClass: "main-title" }, [
          _vm._v("Customize your email")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "main-subtitle" }, [
          _vm._v(
            "Your recipient will receive an email prompting them to redeem their gift. Pick a header, write your message and schedule when you’d like us to notify them and we’ll handle the rest."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "add-gift" }, [
          _c("p", { staticClass: "title" }, [_vm._v("Add a gif header")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "categories-container" },
            _vm._l(_vm.allOccasions, function(occasion) {
              return _c(
                "button",
                {
                  key: occasion,
                  class: occasion == _vm.selectedOccasion ? "selected" : "",
                  on: {
                    click: function($event) {
                      return _vm.selectOccasion(occasion)
                    }
                  }
                },
                [_vm._v(_vm._s(occasion))]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "gifs-container" },
            [
              _vm._l(_vm.currentGifs, function(gif) {
                return _c("img", {
                  key: gif,
                  class: gif == _vm.selectedGif ? "selected" : "",
                  attrs: { src: gif },
                  on: {
                    click: function($event) {
                      return _vm.selectGif(gif)
                    }
                  }
                })
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: _vm.selectedGif == null ? "selected" : "",
                  on: {
                    click: function($event) {
                      return _vm.selectGif(null)
                    }
                  }
                },
                [_c("p", [_vm._v("No Image")])]
              )
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "message-container" }, [
          _c("p", { staticClass: "title" }, [_vm._v("Add your message")]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.message,
                expression: "message"
              }
            ],
            attrs: {
              placeholder: "Start typing here...",
              cols: "30",
              rows: "3",
              id: "message"
            },
            domProps: { value: _vm.message },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.message = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm.emailFileData.length == 1
          ? _c("div", { staticClass: "date-container" }, [
              _c("p", { staticClass: "title" }, [
                _vm._v("Select the date you’d like us to email your recipients")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "date-input" },
                [
                  _c("DatePicker", {
                    attrs: {
                      color: "teal",
                      "trim-weeks": "",
                      "min-date": new Date(),
                      attributes: _vm.calendarAttrs
                    },
                    model: {
                      value: _vm.selectedDate,
                      callback: function($$v) {
                        _vm.selectedDate = $$v
                      },
                      expression: "selectedDate"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "date-details" }, [
                    _c("div", { staticClass: "date-detail" }, [
                      _c("p", { staticClass: "circle teal" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "date-copy" }, [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("Recipients Notification Date:")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "subtitle" }, [
                          _vm._v(_vm._s(_vm.currentDateString))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "date-detail" }, [
                      _c("p", { staticClass: "circle indigo" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "date-copy" }, [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("Estimated Delivery Window:")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "subtitle" }, [
                          _vm._v(_vm._s(_vm.estimatedShippingDate))
                        ])
                      ])
                    ])
                  ])
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isMobile()
          ? _c(
              "button",
              {
                staticClass: "happybox-button yellow",
                class: _vm.isLoading ? "isLoading" : "",
                on: {
                  click: function($event) {
                    return _vm.createGifts()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.buttonText))]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "preview-container" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Email Preview")]),
        _vm._v(" "),
        _c("p", { staticClass: "subtitle" }, [
          _vm._v("Here's what your recipient will see:")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "blue-container" }, [
          _c("div", { staticClass: "mail-preview" }, [
            _c("img", {
              staticClass: "hb-logo",
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/LOGO_300x.gif?v=1658235293"
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "mail-title" }, [
              _vm._v(
                "\n                          Hey [Recipient], [From] sent you a gift! 🎉\n                      "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mail-subtitle" }, [
              _vm._v("Here's their message:")
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "mail-gif",
              attrs: { src: _vm.selectedGif }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "mail-message" }, [
              _vm._v(_vm._s(_vm.message))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "recipients-container" }, [
          _c("p", { staticClass: "recipient-title" }, [_vm._v("Recipients")]),
          _vm._v(" "),
          _c("div", { staticClass: "shipped-table" }, [
            _c("table", [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Name")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Email")]),
                  _vm._v(" "),
                  _vm.emailFileData.length > 1
                    ? _c("th", [_vm._v("Notification Date")])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("th", [_vm._v("From")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.emailFileData, function(recipient) {
                  return _c("tr", { key: recipient.email }, [
                    _c("td", [
                      _vm._v(
                        _vm._s(recipient.firstName) +
                          " " +
                          _vm._s(recipient.lastName)
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(recipient.email))]),
                    _vm._v(" "),
                    _vm.emailFileData.length > 1
                      ? _c("td", [
                          _vm._v(
                            _vm._s(
                              recipient.notificationDate
                                .toLocaleString("en-US", {})
                                .split("T")[0]
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(recipient.from))])
                  ])
                }),
                0
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.isMobile()
          ? _c(
              "button",
              {
                staticClass: "happybox-button yellow",
                class: _vm.isLoading ? "isLoading" : "",
                on: {
                  click: function($event) {
                    return _vm.createGifts()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.buttonText))]
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }